const {
    GET_ALL_BONL_REQUEST,
    GET_ALL_BONL_SUCCESS,
    GET_ALL_BONL_FAIL,
    ADD_BONL_REQUEST,
    ADD_BONL_SUCCESS,
    ADD_BONL_FAIL,
    GET_BONL_REQUEST,
    GET_BONL_SUCCESS,
    GET_BONL_FAIL,
    UPDATE_BONL_REQUEST,
    UPDATE_BONL_SUCCESS,
    UPDATE_BONL_FAIL,
    DELETE_BONL_REQUEST,
    DELETE_BONL_SUCCESS,
    DELETE_BONL_FAIL,
    ADD_BLARTICLE_REQUEST,
    ADD_BLARTICLE_SUCCESS,
    ADD_BLARTICLE_FAIL,
    UPDATE_BLARTICLE_REQUEST,
    UPDATE_BLARTICLE_SUCCESS,
    UPDATE_BLARTICLE_FAIL,
    DELETE_BLARTICLE_REQUEST,
    DELETE_BLARTICLE_SUCCESS,
    DELETE_BLARTICLE_FAIL
} = require("../../actionTypes/Vente/BonL");

  
  function getAllBonL(state = { data: {} }, action) {
    switch (action.type) {
      case GET_ALL_BONL_REQUEST:
        return { loading: true, data: {} };
      case GET_ALL_BONL_SUCCESS:
        return { loading: false, data: action.payload };
      case GET_ALL_BONL_FAIL:
        return { loading: false, error: action.data };
      default:
        return state;
    }
  }
  
  function getBonL(state = { data: {} }, action) {
    switch (action.type) {
      case GET_BONL_REQUEST:
        return { loading: true, data: {} };
      case GET_BONL_SUCCESS:
        return { loading: false, data: action.payload };
      case GET_BONL_FAIL:
        return { loading: false, error: action.data };
      default:
        return state;
    }
  }
  
  function addBonL(state = { data: {} }, action) {
    switch (action.type) {
      case ADD_BONL_REQUEST:
        return { loading: true, data: {} };
      case ADD_BONL_SUCCESS:
        return { loading: false, data: action.payload };
      case ADD_BONL_FAIL:
        return { loading: false, error: action.data };
      default:
        return state;
    }
  }
  
  function updateBonL(state = { data: {} }, action) {
    switch (action.type) {
      case UPDATE_BONL_REQUEST:
        return { loading: true, data: {} };
      case UPDATE_BONL_SUCCESS:
        return { loading: false, data: action.payload };
      case UPDATE_BONL_FAIL:
        return { loading: false, error: action.data };
      default:
        return state;
    }
  }
  
  function deleteBonL(state = { data: {} }, action) {
    switch (action.type) {
      case DELETE_BONL_REQUEST:
        return { loading: true, data: {} };
      case DELETE_BONL_SUCCESS:
        return { loading: false, data: action.payload };
      case DELETE_BONL_FAIL:
        return { loading: false, error: action.data };
      default:
        return state;
    }
  }
  
  function addBLArticle(state = { data: {} }, action) {
    switch (action.type) {
      case ADD_BLARTICLE_REQUEST:
        return { loading: true, data: {} };
      case ADD_BLARTICLE_SUCCESS:
        return { loading: false, data: action.payload };
      case ADD_BLARTICLE_FAIL:
        return { loading: false, error: action.data };
      default:
        return state;
    }
  }
  
  function updateBLArticle(state = { data: {} }, action) {
    switch (action.type) {
      case UPDATE_BLARTICLE_REQUEST:
        return { loading: true, data: {} };
      case UPDATE_BLARTICLE_SUCCESS:
        return { loading: false, data: action.payload };
      case UPDATE_BLARTICLE_FAIL:
        return { loading: false, error: action.data };
      default:
        return state;
    }
  }
  
  function deleteBLArticle(state = { data: {} }, action) {
    switch (action.type) {
      case DELETE_BLARTICLE_REQUEST:
        return { loading: true, data: {} };
      case DELETE_BLARTICLE_SUCCESS:
        return { loading: false, data: action.payload };
      case DELETE_BLARTICLE_FAIL:
        return { loading: false, error: action.data };
      default:
        return state;
    }
  }
  
  export {
    addBonL,
    getBonL,
    updateBonL,
    deleteBonL,
    getAllBonL,
    addBLArticle,
    updateBLArticle,
    deleteBLArticle
  };
  